




















import Vue, { PropType } from "vue";
import { VideoConfig } from "@/components/FacilitatorVideoConfig";

export default Vue.extend({
  name: "FacilitatorVideo",
  props: {
    config: Object as PropType<{ [key: number]: VideoConfig }>,
    id: Number
  },
  computed: {
    title(): string {
      return this.config[this.id].title;
    },
    url(): string {
      return this.config[this.id].url;
    }
  }
});
